export const getRepositoryName = (rawRepositoryName) => {
  const repositoryName = [];
  // match() returns an array of the valid characters, while repositoryNameInput includes
  // the invalid ones. If there's a group of invalid characters, like several spaces in a row,
  // they turn into a single dash.
  const matches = rawRepositoryName.match(/[A-Za-z0-9_.-]/g);
  if (!matches) {
    repositoryName.push('-');
  } else {
    let matchesIndex = 0;
    for (let nameIndex = 0; nameIndex < rawRepositoryName.length; nameIndex++) {
      if (matchesIndex > matches.length) {
        // There's only invalid characters left in the name. We only add a dash
        // once per section of invalid characters, so we can leave it at that.
        repositoryName.push('-');
      } else if (matches[matchesIndex] === rawRepositoryName[nameIndex]) {
        repositoryName.push(matches[matchesIndex]);
        matchesIndex++;
      } else if (matches[matchesIndex - 1] === rawRepositoryName[nameIndex - 1]) {
        // The current character is invalid, and the previous character is valid.
        repositoryName.push('-');
      }
      // else: The previous character is invalid, so a dash has already been added.
    }
  }
  return repositoryName.join('');
};
